const INTERNAL_ACCOUNTS = [
    'pplx-dev@example.com',
    'pplx-dev-pro@example.com',
    'pplx-dev-enterprise@example.com',
    'pplx-dev-max@example.com',
    'fe-test-user@example.com',
    'test-max-1759571532002@8jshrh9w.mailosaur.net',
    'test-max-1759571532003@8jshrh9w.mailosaur.net',
];
export function isInternalUserEmail(email) {
    return Boolean(email && (email.endsWith('@perplexity.ai') || INTERNAL_ACCOUNTS.includes(email)));
}
//# sourceMappingURL=internalUser.js.map